import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { createRefundsByBill } from 'src/app/states/actions/admin.actions';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
  ) { }

  ngOnInit() { }

  buttonClicked = (action) => {
    this.dialogRef.close({ action });
    if (this.data.refunds) {
      this.store.dispatch(new createRefundsByBill(this.data.refunds));
    }
  }
}
